package com.klantenstop.web.components.dialogs.manageCompanyReview

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import com.klantenstop.web.components.Dialog
import com.klantenstop.web.components.KsStarRating
import com.klantenstop.web.data.models.domain.Review
import com.materialkobweb.styles.MaterialColorVars
import com.materialkobweb.components.widgets.DsEditableArea
import com.materialkobweb.components.widgets.DsMaterialSymbols
import com.materialkobweb.components.widgets.FilledButton
import com.materialkobweb.components.widgets.IconButton
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.marginBlock
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.ButtonSize
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.coroutines.flow.collectLatest
import org.jetbrains.compose.web.attributes.ButtonType
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Text

@Composable
fun ManageCompanyReviewDialog(
    currentUserReview: Review? = null,
    isSaving: Boolean = false,
    onHideDialog: () -> Unit,
    onSaveReview: (Int, String) -> Unit
) {
    val viewModel = remember(currentUserReview) { ManageCompanyReviewViewModel(currentUserReview) }
    val state by viewModel.state.collectAsState()

    LaunchedEffect(Unit) {
        viewModel.effect.collectLatest {
            when (it) {
                is ManageCompanyReviewContract.Effect.SaveCompanyReview -> {
                    onSaveReview(it.rating, it.reviewText)
                }
            }
        }
    }

    ManageCompanyReviewDialogContent(
        state = state,
        isSaving = isSaving,
        sendIntent = viewModel::sendIntent,
        onHideDialog = onHideDialog
    )
}

@Composable
private fun ManageCompanyReviewDialogContent(
    state: ManageCompanyReviewContract.State,
    isSaving: Boolean,
    sendIntent: (ManageCompanyReviewContract.Intent) -> Unit,
    onHideDialog: () -> Unit
) {
    Dialog(
        onHideDialog = onHideDialog
    ) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween
        ) {
            H2(
                attrs = Modifier.marginBlock(0.px).toAttrs()
            ) {
                Text("Review toevoegen")
            }

            IconButton(
                modifier = Modifier,
                size = ButtonSize.SM,
                type = ButtonType.Button,
                enabled = true,
                onClick = onHideDialog,
                content = {
                    DsMaterialSymbols(
                        icon = "close",
                        modifier = Modifier.fontSize(20.px)
                    )
                }
            )
        }

        KsStarRating(
            modifier = Modifier.margin(top = 36.px, bottom = if (state.hasAttemptedSave && !state.isRatingValid) 4.px else 24.px),
            initialRating = state.rating
        ) {
            sendIntent(ManageCompanyReviewContract.Intent.UpdateReviewRating(it))
        }

        if (state.hasAttemptedSave && !state.isRatingValid) {
            SpanText(
                text = "Selecteer een beoordeling (1–5 sterren)",
                modifier = Modifier
                    .fillMaxWidth()
                    .margin(bottom = 24.px)
                    .fontSize(12.px)
                    .color(MaterialColorVars.Error.value())
            )
        }

        DsEditableArea(
            modifier = Modifier.fillMaxWidth(),
            id = "inputStatusDescription",
            label = "Schrijf jouw mening",
            placeholder = "Beschrijf hier jouw ervaring",
            valid = !state.hasAttemptedSave || state.isReviewTextValid,
            value = state.reviewText,
            onValueChange = {
                sendIntent(ManageCompanyReviewContract.Intent.UpdateReviewText(it))
            }
        )

        Row(
            modifier = Modifier.fillMaxWidth().margin(top = 4.px),
            horizontalArrangement = Arrangement.SpaceBetween
        ) {
            if (state.hasAttemptedSave && !state.isReviewTextValid) {
                SpanText(
                    text = if (state.reviewText.isBlank()) "Vul een reviewtekst in" else "Maximaal ${ManageCompanyReviewContract.REVIEW_MAX_LENGTH} tekens toegestaan",
                    modifier = Modifier
                        .fontSize(12.px)
                        .color(MaterialColorVars.Error.value())
                )
            } else {
                // Spacer to push counter to the right
                SpanText(text = "", modifier = Modifier.fontSize(12.px))
            }

            val charCount = state.reviewText.length
            val isOverLimit = charCount > ManageCompanyReviewContract.REVIEW_MAX_LENGTH
            SpanText(
                text = "$charCount / ${ManageCompanyReviewContract.REVIEW_MAX_LENGTH}",
                modifier = Modifier
                    .fontSize(12.px)
                    .color(if (isOverLimit) MaterialColorVars.Error.value() else MaterialColorVars.Outline.value())
            )
        }

        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(top = 16.px),
            horizontalArrangement = Arrangement.End
        ) {
            FilledButton(
                enabled = state.hasChanged && !isSaving,
                onClick = {
                    sendIntent(ManageCompanyReviewContract.Intent.SaveCompanyReview)
                }
            ) {
                Text("Publiceer review")
            }
        }
    }
}
